export const ACTION_PREFIX = 'MOBILE_SKIP_VERIFICATION';

export const actionTypes = {
  SAVE_MOBILE: 'SAVE_MOBILE',
  UPDATE_ERROR_MESSAGE: 'UPDATE_ERROR_MESSAGE',
};
